module.exports = __webpack_public_path__ + "img/vippack-active.2a0c8118.svg";